import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-[hsl(150,35%,18%)] via-[hsl(150,30%,22%)] to-[hsl(150,25%,28%)] py-10 md:py-10">
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.08]">
        <svg viewBox="0 0 800 400" className="h-full w-full" fill="none" stroke="white" strokeWidth="2">
          <circle cx="400" cy="200" r="80" />
          <line x1="400" y1="0" x2="400" y2="400" />
          <circle cx="400" cy="200" r="4" fill="white" />
          <rect x="20" y="20" width="760" height="360" rx="0" />
          <rect x="20" y="100" width="120" height="200" />
          <rect x="20" y="150" width="50" height="100" />
          <path d="M 140 160 A 40 40 0 0 1 140 240" />
          <rect x="660" y="100" width="120" height="200" />
          <rect x="730" y="150" width="50" height="100" />
          <path d="M 660 160 A 40 40 0 0 0 660 240" />
          <path d="M 20 30 A 10 10 0 0 1 30 20" />
          <path d="M 770 20 A 10 10 0 0 1 780 30" />
          <path d="M 780 370 A 10 10 0 0 1 770 380" />
          <path d="M 30 380 A 10 10 0 0 1 20 370" />
        </svg>
      </div>
      <div className="container relative z-10 animate-fade-in text-center">
        <h1 className="text-4xl font-black leading-[1.1] tracking-tight text-white md:text-5xl lg:text-6xl">
          Pokaż swoją kolekcję
          <br />
          koszulek <span className="text-[#22c55e]">piłkarskich</span>
        </h1>
        <p className="mx-auto mt-5 max-w-[600px] text-base text-white/80 md:text-lg">
          Twoje koszulki to coś więcej niż kolekcja. To historia, emocje i momenty zapisane w materiale. Kataloguj je, pokazuj światu i łącz się z ludźmi, którzy czują do nich to samo.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/auth?tab=register">
            <Button size="lg" className="bg-[#22c55e] text-base text-white hover:bg-[#16a34a]">
              Stwórz kolekcję
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}